import { render, staticRenderFns } from "./TagSvgWithColor.vue?vue&type=template&id=17bad638&scoped=true"
import script from "./TagSvgWithColor.vue?vue&type=script&lang=js"
export * from "./TagSvgWithColor.vue?vue&type=script&lang=js"
import style0 from "./TagSvgWithColor.vue?vue&type=style&index=0&id=17bad638&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17bad638",
  null
  
)

export default component.exports